import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { MembershipModel } from '@smarttask-common/src/lib/models/Membership/Core/MembershipModel';

export enum MembershipActionTypes {
    ADD_MEMBER = '[Membership] Create Member',
    ADD_MEMBERS = '[Membership] Add Members',
    UPSERT_MEMBER = '[Membership] Upsert Member',
    UPSERT_MEMBERS = '[Membership] Upsert Members',
    UPDATE_MEMBER = '[Membership] Update Member',
    UPDATE_MEMBERS = '[Membership] Update Members',
    DELETE_MEMBER = '[Membership] Delete Member',
    DELETE_MEMBERS = '[Membership] Delete Members',
    DELETE_ALL_MEMBERS = '[Membership] Delete All Members',
    DELETE_ALL = '[Membership] Delete All',

    UPDATE_SELECTED_ID = '[Membership] Update SelectedId',
}

export class UpdateSelectedMemberId implements Action {
    readonly type = MembershipActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_membership_id: string) {}
}

export class AddOne implements Action {
    readonly type = MembershipActionTypes.ADD_MEMBER;
    constructor(public member: MembershipModel) {}
}

export class AddMany implements Action {
    readonly type = MembershipActionTypes.ADD_MEMBERS;
    constructor(public members: Array<MembershipModel>) {}
}

export class UpsertOne implements Action {
    readonly type = MembershipActionTypes.UPSERT_MEMBER;

    constructor(public member: MembershipModel) {}
}

export class UpsertMany implements Action {
    readonly type = MembershipActionTypes.UPSERT_MEMBERS;
    constructor(public members: Array<MembershipModel>) {}
}

export class UpdateOne implements Action {
    readonly type = MembershipActionTypes.UPDATE_MEMBER;
    constructor(public member: Update<MembershipModel>) {}
}

export class UpdateMany implements Action {
    readonly type = MembershipActionTypes.UPDATE_MEMBERS;
    constructor(public members: Array<Update<MembershipModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = MembershipActionTypes.DELETE_MEMBER;
    constructor(public membership_id: string) {}
}

export class DeleteMany implements Action {
    readonly type = MembershipActionTypes.DELETE_MEMBERS;
    constructor(public membership_ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = MembershipActionTypes.DELETE_ALL_MEMBERS;
    constructor(public membership_ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = MembershipActionTypes.DELETE_ALL;
    constructor() {}
}

export type MembershipActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedMemberId;
